var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "flex flex-col items-center"
  }, [_vm.showBillingCycleToggle ? _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "savings-label mt-6 self-end w-1/2 text-center text-sm whitespace-nowrap"
  }, [_vm._v("\n\t\t\tSave up to $" + _vm._s(_vm.annualMaxDiscount) + "\n\t\t")]), _vm._v(" "), _c('slide-toggle', {
    staticClass: "mt-1",
    attrs: {
      "input-id": "plan-picker-billing-cycle",
      "on-label": "Yearly",
      "off-label": "Monthly",
      "reverse": false,
      "outline": true,
      "animate": false
    },
    model: {
      value: _vm.billingCycleBoolean,
      callback: function ($$v) {
        _vm.billingCycleBoolean = $$v;
      },
      expression: "billingCycleBoolean"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-8 flex flex-col-reverse gap-6"
  }, _vm._l(_vm.plans, function (plan, index) {
    return _c('div', {
      key: plan.name,
      staticClass: "plan-wrapper max-w-lg rounded-lg cursor-pointer",
      class: {
        active: index === _vm.selectedPlan
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('update:selectedPlan', index);
        }
      }
    }, [_c('div', {
      staticClass: "plan py-5 px-4 flex flex-col gap-4"
    }, [_c('div', {
      staticClass: "font-semibold text-lg leading-6"
    }, [_vm._v(_vm._s(plan.title))]), _vm._v(" "), _c('div', {
      staticClass: "flex flex-col gap-2"
    }, [plan.priceDiscountedFrom && plan.priceDiscountedFrom[_vm.billingCycle] ? _c('div', {
      staticClass: "price-discounted-from"
    }, [_c('span', {
      staticClass: "font-medium text-xl leading-6 tracking-wider"
    }, [_vm._v("\n\t\t\t\t\t\t\t$" + _vm._s(plan.priceDiscountedFrom && plan.priceDiscountedFrom[_vm.billingCycle])), _c('span', {
      staticClass: "text-lg font-light"
    }, [_vm._v("/" + _vm._s(_vm.billingCycle === 1 ? 'yr' : 'mo'))])])]) : _vm._e(), _vm._v(" "), _c('div', {
      class: {
        'plan-with-discount': plan.priceDiscountedFrom && plan.priceDiscountedFrom[_vm.billingCycle]
      }
    }, [_c('span', {
      staticClass: "font-semibold text-2xl leading-9"
    }, [_vm._v("$" + _vm._s(plan.price[_vm.billingCycle]))]), _vm._v(" "), _c('span', {
      staticClass: "text-lg leading-6"
    }, [_vm._v("/" + _vm._s(_vm.billingCycle === 1 ? 'yr' : 'mo'))])])]), _vm._v(" "), _c('div', {
      staticClass: "plan-description text-sm leading-5"
    }, [_vm._v(_vm._s(plan.description))])])]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };